(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fv-restock"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('fv-restock')){
  customElements.define('fv-restock',class extends HTMLElement{
    connectedCallback(){
      this.variants=JSON.parse(this.querySelector('script').textContent);
      this.signup=this.querySelector('form');this.status=this.querySelector('[data-restock-status]');
      this.root=this.closest('product-info')||this.parentElement;
      this.sync=()=>{
        const field=document.getElementById(this.dataset.formId)?.querySelector('input[name="id"]');
        const variant=this.variants.find(v=>String(v.id)===field?.value);
        if(this.current===variant?.id)return;
        this.current=variant?.id;this.hidden=!variant||variant.available;
        this.querySelector('[data-restock-variant]').textContent=variant?.title||'';
        this.status.textContent='';this.signup.elements.consent.checked=false;
      };
      this.observer=new MutationObserver(this.sync);this.observer.observe(this.root,{subtree:true,childList:true,attributes:true,attributeFilter:['value']});
      this.onChange=()=>setTimeout(this.sync,0);this.root.addEventListener('change',this.onChange);this.sync();
      this.signup.onsubmit=async event=>{
        event.preventDefault();if(this.busy||!this.signup.reportValidity())return;
        this.sync();const variant=this.variants.find(v=>v.id===this.current);if(!variant||variant.available)return;
        this.busy=true;const submit=this.signup.querySelector('button');submit.disabled=true;
        this.status.textContent=this.dataset.saving;
        try{
          const response=await fetch(this.dataset.endpoint,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({email:this.signup.elements.email.value,consent:this.signup.elements.consent.checked,variant:String(variant.id),product:this.dataset.productId})});
          const result=await response.json();if(!response.ok||!result.ok)throw Error(result.error||this.dataset.failure);
          this.status.textContent=result.message+' ('+variant.title+')';this.signup.elements.email.value='';this.signup.elements.consent.checked=false;
        }catch(error){this.status.textContent=error.message||this.dataset.failure;}
        finally{this.busy=false;submit.disabled=false;}
      };
    }
    disconnectedCallback(){this.observer?.disconnect();this.root?.removeEventListener('change',this.onChange);}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fv-sample-card"] && !Shopify.designMode) return;
  try {
    if (!window.fvSampleFormsReady) {
  window.fvSampleFormsReady = true;
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('.fv-sample-form')) return;
    event.preventDefault();
    if (window.fvSampleAdding) return;
    window.fvSampleAdding = true;
    const buttons = document.querySelectorAll('.fv-sample-form button');
    buttons.forEach(button => { button.disabled = true; });
    const feedback = form.closest('.fv-sample-body').querySelector('.fv-sample-feedback');
    const data = new FormData(form);
    data.set('sections', 'cart-icon-bubble');
    data.set('sections_url', window.location.pathname);
    try {
      const response = await fetch(form.action + '.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || feedback.dataset.error);
      feedback.textContent = feedback.dataset.success;
      const cart = document.querySelector('#cart-icon-bubble');
      if (cart && result.sections && result.sections['cart-icon-bubble']) {
        const html = new DOMParser().parseFromString(result.sections['cart-icon-bubble'], 'text/html');
        cart.innerHTML = html.querySelector('.shopify-section')?.innerHTML || result.sections['cart-icon-bubble'];
      }
    } catch (error) {
      feedback.textContent = error.message || feedback.dataset.error;
    } finally {
      buttons.forEach(button => { button.disabled = false; });
      window.fvSampleAdding = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
